import {Unit} from './ItemMasterInterfaces';

export const getPackagingString = (packaging: string) => {
  if (!packaging) return '';

  packaging = getUppercase(packaging);

  if (packaging === 'Each') {
    return 'Eaches';
  } else {
    return packaging + 's';
  }
};

export const getFromUnitType = (unit: string | Unit) => {
  if (!unit) return '';
  if ((unit as Unit) && (unit as Unit).expression) return (unit as Unit).expression;
  return unit as string;
};

export const getUppercase = (packaging: string | Unit) => {
  const packagingString = getFromUnitType(packaging);
  return packagingString.charAt(0).toUpperCase() + packagingString.slice(1);
};
